import { axios } from './axios';

export const rbacApi = {
  async getMyRoles() {
    return axios.get('/me/roles');
  },
  async getUserPermissionMatrix() {
    return axios.get('/user-permissions-matrix');
  },
  async getSubmodulePermissionMatrix(parentId: number[]) {
    return axios.get<number[]>(
      `/user-permissions-matrix/submodule-permissions`,
      { params: { groupId: parentId } }
    );
  }
};
